import React from 'react';
import { connect } from 'react-redux';


class Logo extends React.Component {

    render() {
	    const logo = require('../../resources/isotipo_B.png')
        let url = "/project-page?project_id=" + this.props.projectData.id
        let target = '_self'
        if (window.frameElement !== null) {
            target = '_blank'
        }

        if (this.props.projectData.attributes.published) {
            url = "/"
            target = '_blank'
        }
    
        return(
            <a className='d-flex justify-content-center' href={url} target={target}>
                <img className="logo" src={logo} alt="logo"/>
            </a>
        );
    } 
}

function mapStateToProps( state ){
    return { 
    	projectData: state.projectData
    }
}

export default connect(mapStateToProps)(Logo);